// extracted by mini-css-extract-plugin
export default {"load-testing":"LoadTesting_load-testing__Dsl6X","load-testing-view":"LoadTesting_load-testing-view__eXCGM","load-testing-view-heading":"LoadTesting_load-testing-view-heading__wq2E-"};